define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {

        },

        init: function () {  
            var self = this;

            var tabLinks = self.el.querySelectorAll(".Tabs-link");
            Array.prototype.forEach.call(tabLinks, function (tabLink) {
                tabLink.addEventListener('click', function () {
                    const element = document.querySelector(".Tabs--sticky");
                    element.scrollIntoView();
                    window.scrollBy(0, 5); // offset 5 px for menu to show
                });
            }) 
        } 
    });
});